export default {
  name: 'VietnameseTeachersDayBlog',
  data() {
    return {
      observer: null,
      showImageModal: false,
      selectedImage: { src: '', title: '', subtitle: '', bg: '' },
      images: [
        { src: 'https://www.songhancapital.com/assets/image/251120_01.jpg', title: 'Ảnh tri ân 1', bg: 'linear-gradient(135deg,#f97316,#fb923c)' },
        { src: 'https://www.songhancapital.com/assets/image/251120_02.jpg', title: 'Ảnh tri ân 2', bg: 'linear-gradient(135deg,#06b6d4,#0ea5e9)' },
        { src: 'https://www.songhancapital.com/assets/image/251120_03.jpg', title: 'Ảnh tri ân 3', bg: 'linear-gradient(135deg,#8b5cf6,#a78bfa)' },
        { src: 'https://www.songhancapital.com/assets/image/251120_04.jpg', title: 'Ảnh tri ân 4', bg: 'linear-gradient(135deg,#34d399,#60a5fa)' }
      ],
    };
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.initializeAnimations();
    document.addEventListener('keydown', this.handleEscapeKey);
  },
  methods: {
    goToContact() {
      if (this.$router) this.$router.push('/contact');
      else window.location.href = '/contact';
    },
    scrollToGallery() {
      this.$nextTick(() => {
        const el = document.querySelector('#gallery') || document.querySelector('.gallery-grid');
        if (el) {
          const yOffset = -80; // account for fixed header
          const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      });
    },
    openImageModal(item) {
      // item is an object with src, title, subtitle, caption, bg
      this.selectedImage = {
        src: item.src || '',
        title: item.title || '',
        subtitle: item.subtitle || '',
        caption: item.caption || '',
        bg: item.bg || 'linear-gradient(135deg,#667eea,#764ba2)'
      };
      this.showImageModal = true;
      document.body.style.overflow = 'hidden';
    },
    closeImageModal() {
      this.showImageModal = false;
      this.selectedImage = { src: '', title: '', subtitle: '', caption: '', bg: '' };
      document.body.style.overflow = 'auto';
    },
    handleEscapeKey(event) {
      if (event.key === 'Escape' && this.showImageModal) {
        this.closeImageModal();
      }
    },
    initializeAnimations() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('visible');
              const delay = Array.from(entry.target.parentNode.children).indexOf(entry.target) * 100;
              setTimeout(() => {
                entry.target.style.transitionDelay = `${delay}ms`;
              }, 0);
            }
          });
        },
        { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
      );

      this.$nextTick(() => {
        const elements = document.querySelectorAll('.animate-on-scroll');
        elements.forEach((el) => this.observer.observe(el));
      });
    }
  },
  beforeUnmount() {
    if (this.observer) this.observer.disconnect();
    document.removeEventListener('keydown', this.handleEscapeKey);
    document.body.style.overflow = 'auto';
  }
};
